import { useState, useEffect } from "react";
import _ from "lodash";
import { getDevice, devices } from "./getDevice";

const useDimensions = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = _.debounce(() => {
      if (getDevice() !== devices.mobile) window.location.reload();
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    }, 500);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
};

export default useDimensions;
